export default "__VITE_ASSET__CCOua6iF__"